export default __webpack_public_path__ + "static/100-2560651d8ec32dada20c69ae921d47da.jpg";